import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Injector } from '@angular/core';
import { EmployerPlanDesignatedUnit } from '../models/employers/plans/employer-plan-designated-unit';
import { ModalUtils } from '../utils/modal-utils';
import { CreateDesignatedUnitModalComponent } from '../views/shared/components/tables/designated-units-table-card/create-designated-unit-modal/create-designated-unit-modal.component';

export class ModalCreateDesignatedUnit {
  static open(
    ngbModal: NgbModal,
    injector: Injector,
    existingDesignatedUnits: EmployerPlanDesignatedUnit[],
    employerPlanId: number
  ): Promise<EmployerPlanDesignatedUnit | null> {
    const modalRef = ngbModal.open(CreateDesignatedUnitModalComponent, ModalUtils.defaultLargeModalOptions(injector));
    const compInstance = modalRef.componentInstance as CreateDesignatedUnitModalComponent;
    compInstance.setExistingDesignatedUnits(existingDesignatedUnits);
    compInstance.setEmployerPlanId(employerPlanId);
    return modalRef.result;
  }
}
